import { createBrowserRouter, Navigate } from 'react-router-dom';

import { root } from '~/preloaded';
import DefaultLayout from '~/layouts/DefaultLayout/DefaultLayout';
import routesConfig from '~/router/routesConfig';

const router = createBrowserRouter(
  [
    {
      path: root,
      Component: DefaultLayout,
      children: routesConfig,
    },
    {
      path: '*',
      element: <Navigate to={root} replace={true} />,
    },
  ],
  {
    future: {
      v7_normalizeFormMethod: true,
    },
  },
);

export default router;
